import { z } from 'zod'
import { eventTimingsSchema } from './event-timings'

export const memberOpenedSchema = z.object({
  programUuid: z.string().uuid(),
  masterTaskId: z.string(),
  memberStatus: z.string(),
  taskList: z.array(z.object({
    uuid: z.string(),
    type: z.string(),
  })),
}).extend(eventTimingsSchema.shape)
